import notify from 'devextreme/ui/notify';
import * as _ from 'lodash';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DeliveryNotesService } from './delivery-notes.service';
import { DeliveryNotesPDFModalComponent } from './delivery-notes-pdf-modal/delivery-notes-pdf-modal.component';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { AlertService } from '../../../shared/services/alert.service';
import { AuthService } from '../../../shared/services/auth.service';
import { IConfirmationDialogOptions } from '../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { DialogService } from '../../../shared/services/dialog/dialog.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { BillingDocumentsModalComponent } from '../../billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { IBillingDocumentTypes } from '../../billing-documents-page/billing-documents/billing-documents.interface';
import { ProductsService } from '../../products-page/products/products.service';
import { TaskHttpService } from '../../tasks-page/tasks/task-http.service';
import { TaskModalComponent } from '../../tasks-page/tasks/task-modal/task-modal.component';
import { ITask } from '../../tasks-page/tasks/task.interface';
import { IQuote } from '../../quotes-page/quotes/quotes.interface';

let self: any;

@Component({
  selector: 'app-delivery-notes',
  templateUrl: './delivery-notes.component.html',
  styleUrls: ['./delivery-notes.component.css']
})
export class DeliveryNotesComponent implements OnInit {
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    filters: {

    },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  deliveryNotes: any;
  curr!: string;
  companyId!: string;

  constructor(
    public _TaskHttpService: TaskHttpService,
    public _ProductsService: ProductsService,
    private _DeliveryNotesService: DeliveryNotesService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilsService: UtilsService,
    private alertService: AlertService,
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.companyId = this._AuthService.companyId();
    this.isDev = this._AuthService.isRole('dev');
    this.curr = this._AuthService.currency();
    this.filter.company = this._AuthService.companyId();
    this.getDeliveryNotes(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      //console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getDeliveryNotes(true);
      }
    }, 1000);
  }

  getDeliveryNotes(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.deliveryNotes = [];
      this.clearSelection();
    }
    const filter = _.cloneDeep(this.filter);
    if (filter.filters.dateStart) filter.filters.dateStart = this._UtilsService.date.toUTC(filter.filters.dateStart + 'T00:00:00.000Z');
    if (filter.filters.dateEnd) filter.filters.dateEnd = this._UtilsService.date.toUTC(filter.filters.dateEnd + 'T23:59:59.999Z');
    this._DeliveryNotesService.getDeliveryNotes(filter).subscribe((deliveryNotes: any) => {
      //console.log(deliveryNotes)
      this.deliveryNotes = _.concat(this.deliveryNotes, deliveryNotes);
      this.thereAreMore = deliveryNotes.length >= self.filter.limit;
      this.loading = false;
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      self.filter.skip += self.filter.limit;
      this.getDeliveryNotes();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  openDeliveryNote(quote: IQuote) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(DeliveryNotesPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = quote;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }

  openTasksModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = task;
    self.dialogRef.componentInstance.scheduling = scheduling;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      // if (result) this.getTasks(true);
    });
  }

  async invoiceTask(task: ITask) {

    /*  REFACTOR ************************************/
    task = await this._TaskHttpService.getTask(task._id || '').toPromise() as ITask;
    // for (let el of task.products) {
    //   console.log(el)
    //   const product = await this._ProductsService.getProduct(el.product._id).toPromise();
    //   console.log(product)
    //   el.product = product;
    // }
    /*  REFACTOR ************************************/

    const modalOptions: IConfirmationDialogOptions = {
      title: "Facturar albarán",
      message: "¿Está seguro de que desea facturar este albarán?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
      if (confirmation) {
        let config = new MatDialogConfig();
        config.width = '1200px';
        config.maxWidth = '90vw';
        config.viewContainerRef = this._viewContainerRef;
        self.dialogRef = this._dialog.open(BillingDocumentsModalComponent, config);
        self.dialogRef.componentInstance.tasks = [task];
        self.dialogRef.componentInstance.document = {
          type: IBillingDocumentTypes.INVOICE,
          client: task.client
        };
        self.dialogRef.componentInstance.readOnly = false;
        self.dialogRef.componentInstance.editting = true;
        self.dialogRef.componentInstance.redirectToBill = true;

        self.dialogRef.afterClosed().subscribe((result: any) => {
        });
      }
    });
  }

  download(document: any) {
    const name = `Albarán ${document.serieAndNumber} de ${this._AuthService.company().name} - Fecha ${document.date.substr(0, 10)}`;
    this._DeliveryNotesService.download(document._id, name);
    setTimeout(() => {
    }, 2000);
  }

  sendEmail(document: any) {

    if (document.client.emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Enviar por email",
        message: "¿Desea enviar el albarán a la siguiente dirección? " + document.client.emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._DeliveryNotesService.sendEmail(document._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this.alertService.warn("El cliente no tiene un email cargado");
    }
  }

  requestSignature(document: any) {

    if (document.client.emails.length > 0) {

      const modalOptions: IConfirmationDialogOptions = {
        title: "Solicitud de firma",
        message: "¿Desea enviar la solicitud de firma del albarán a la siguiente dirección? " + document.client.emails[0].address,
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };

      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
        .subscribe((confirmation: any) => {
          if (confirmation) {
            let data = {};
            this._DeliveryNotesService.requestSignature(document._id, data).subscribe((result: any) => {
              result ? notify(`Email enviado correctamente`, "info", 1500) : notify(`Error al enviar email`, "error", 1500);
            });
          }
        });
    } else {
      this.alertService.warn("El cliente no tiene un email cargado");
    }
  }

  openFilter() {
    //console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getDeliveryNotes(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }

  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];
  
      // Verificar si todos los elementos están seleccionados
      const allSelected = this.deliveryNotes.every((deliveryNote: any) => {
        const id = deliveryNote._id || '';
        return this.selection[id];
      });
  
      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };
  
      // Aplicar el nuevo estado a todos los elementos
      this.deliveryNotes.forEach((deliveryNote: any) => {
        const id = deliveryNote._id || '';
        this.selection[id] = newValue;
      });
    }
  
    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
  

}